<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table (detail)="onDetail($event)" [columns]="columns" [dataProviderParams]="params" [dataProvider]="importLogsService"
                  [title]="'Import Logs'"></data-table>
</page-content>
